const wpcf7 = () => {
  const contactForms = document.querySelectorAll(
    '.js-contact-form .wpcf7-form',
  );
  if (contactForms) {
    // wpcf7mailsent
    contactForms.forEach(form => {
      form.addEventListener('wpcf7mailsent', () => {
        setTimeout(() => {
          form.querySelectorAll('.js-file').forEach(file => {
            const fileElement = file.closest('div.is-chosen');
            if (fileElement) {
              fileElement.remove();
            }
          });
          form.querySelectorAll('.c-select__title').forEach(select => {
            // eslint-disable-next-line no-param-reassign
            select.textContent = 'Wybierz';
          });
        }, 200);
      });
    });
  }
};

export default wpcf7;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/wpcf7.js